export default "__VITE_ASSET__zGWc3LKX__"